/**
 * Canonical tone IDs for accounts UserProfile; must match backend `brands.constants` TONE_* .
 */

const LEGACY_TONE_MAP = {
  sharp_rebel: "question_master",
};

/** Map deprecated API values (e.g. stored reply context) to current tone ids. */
export function normalizeToneValue(value) {
  if (value == null || value === "") {
    return value;
  }
  const key = String(value);
  return LEGACY_TONE_MAP[key] || key;
}

export const TONE_OPTIONS = [
  {
    value: "helpful_peer",
    title: "The Helpful Peer",
    compactName: "Helpful peer",
    subtitle: "Warm colleague, curious, low pressure.",
    example:
      "Thanks for the note. Happy to share how a few peers handled [problem area] lately if a quick skim saves you a detour.",
    icon: "handshake",
  },
  {
    value: "question_master",
    title: "The Question Master",
    compactName: "Question master",
    subtitle: "Kind and helpful; you close with questions that open the problem.",
    example:
      "Thanks for the detail. What is the earliest sign for you that [outcome] is drifting, before anyone escalates it?",
    icon: "live_help",
  },
  {
    value: "busy_founder",
    title: "The Busy Founder",
    compactName: "Busy founder",
    subtitle: "Fast, direct, no filler.",
    example:
      "Thanks. Still losing a day a week to [pain point]? We built [Product] for that.",
    icon: "bolt",
  },
];
